module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-desktop",
    attrs: {
      "role": "navigation"
    }
  }, [_c('ul', {
    staticClass: "nav nav--inline nav--primary"
  }, [_c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('')
    }
  }, [_vm._v("หน้าแรก")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('our-work')
    }
  }, [_vm._v("งานของเรา")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('about')
    }
  }, [_vm._v("เกี่ยวกับเรา")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('good-governance')
    }
  }, [_vm._v("ธรรมาภิบาล")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('take-action')
    }
  }, [_vm._v("ร่วมร้อยพลัง")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27ee0414","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenuTop.vue
// module id = 1124
// module chunks = 0